import { css } from '../../../styled-components';
import { ButtonSize } from '../utils';
const paddingSwitcher = size => {
  switch (size) {
    case ButtonSize.small:
      return `5px 10px`;
    case ButtonSize.large:
      return `10px 20px`;
    case ButtonSize.normal:
      return `5px 14px`;
    default:
      throw new RangeError(`Enum ${size} is not defined.`);
  }
};
export const migipediaStyles = css`
  display: inline-block;
  margin-bottom: 0;
  font-family: ${({
  theme: {
    fonts
  }
}) => fonts.families.text};
  font-weight: ${({
  size,
  theme: {
    fonts
  }
}) => size === ButtonSize.small ? 'bold' : fonts.weights.regular};
  ${({
  uppercase
}) => uppercase ? 'text-transform: uppercase;' : ''}
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  outline: none;
  cursor: pointer;
  border: 0px solid transparent;
  white-space: nowrap;
  padding: ${({
  size
}) => paddingSwitcher(size || ButtonSize.normal)};
  font-size: ${({
  size,
  theme: {
    fonts: {
      sizes
    }
  }
}) => size === ButtonSize.small ? sizes.text.xsmall : size === ButtonSize.large ? sizes.text.large : '16px'};
  border-radius: ${({
  theme: {
    borderRadiuses
  }
}) => borderRadiuses.medium};
  transition:
    background-color 100ms linear,
    color 100ms linear,
    border 100ms linear;
  color: ${({
  light,
  theme: {
    themeId,
    colors: {
      tints: {
        white,
        black
      }
    }
  }
}) => light || themeId === 'migipediaDark' ? black[90] : white[100]};
  background-color: ${({
  light,
  disabled,
  theme: {
    colors: {
      brand,
      tints
    }
  }
}) => light ? disabled ? tints.gray['10'] : tints.white[100] : disabled ? tints.gray['50'] : brand.primary[100]};

  &:not(:disabled) {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
  &:hover:not(:disabled) {
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  }
  &:active:not(:disabled) {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  }
  &:focus:not(:disabled) {
    ${({
  theme: {
    colors
  }
}) => {
  return `outline: 2px solid ${colors.brand.secondary[100]}`;
}}
    ${({
  light,
  theme: {
    colors
  }
}) => light && `outline: 2px solid ${colors.tints.gray[40]}`}
  }

  &:hover:disabled {
    cursor: not-allowed;
  }
`;